export default {
	header:         state => state.header,
	listOfStatuses:      state => state.listOfStatuses,
};
